module.exports = __webpack_public_path__ + "img/hall-page-background.02ac9fb8.png";